// extracted by mini-css-extract-plugin
export default {"title":"LinedDecorTitleGreen_title__AnAoZ"};